module.exports = __webpack_public_path__ + "img/app-store.d54ac2d7.png";